import WebflowIntegrationForm from '@/components/Integrations/WebflowIntegrationForm/WebflowIntegrationForm.vue'

export default {
  name: 'WebflowIntegration',
  components: {
    WebflowIntegrationForm
  },
  computed: {
    contentplanId () {
      return parseInt(this.$route.params.contentplanId)
    },
    workspaceId () {
      return parseInt(this.$route.params.workspaceId)
    }
  }
}
